import type { CompanyListItem } from '@tandemone/types'
import { createContext } from 'react'

import type { PendingAttachment } from './attachment-picker'

/** /messages/new form state. lifted out of the component into a
 * reducer-driven context so the form fields, attachment uploads, and
 * submission state are all coordinated through dispatched actions .
 * matches the signup form pattern.
 */

type FormState = {
  subject: string
  body: string
  recipients: CompanyListItem[]
  attachments: PendingAttachment[]
  error: string
  submitting: boolean
}

type Action =
  | { type: 'SET_SUBJECT'; payload: string }
  | { type: 'SET_BODY'; payload: string }
  | { type: 'SET_RECIPIENTS'; payload: CompanyListItem[] }
  | { type: 'SET_ATTACHMENTS'; payload: PendingAttachment[] }
  | { type: 'SET_ERROR'; payload: string }
  | { type: 'CLEAR_ERROR' }
  | { type: 'SUBMIT_START' }
  | { type: 'SUBMIT_END' }

type NewConversationContextType = {
  state: FormState
  dispatch: React.Dispatch<Action>
  isValid: boolean
  handleSubmit: (event: React.FormEvent) => void
}

export const NewConversationContext =
  createContext<NewConversationContextType | null>(null)

export type { Action, FormState, NewConversationContextType }
